<script lang="ts">
    import { v4 as v4uuid } from 'uuid';
    import { paramsService } from "../services";
    import { Icon } from "sveltestrap";
    import { Param } from "../Model/Param";
    import AddParamModal from "./AddParamModal.svelte";

    export let paramType: string;

    let params: Param[];

    let paramTypeModal = null;
    let addParam: boolean = false;
    let editParam: Param;
    let removeButton: boolean;

    $: load(paramType);

    async function load(paramType){

        params = await paramsService.findByType(paramType);

        params.sort((a,b) => {
            return a.name < b.name ? -1 : 1;
        })
        
    }

    function addNewParam (param){
        if (param?.type == paramTypeModal) {

            let paramEdit = params.find(p => p.id == param.id)

            if (paramEdit) {
                paramEdit = param
            }else{
                params.push(param);
            }
            editParam = null
            param = null
            params = params;
        }
        
    }

    function removeParam (param){
        if (param?.type == paramTypeModal) {

            params.splice(params.findIndex((elemento, indice) => {
                if (elemento.id === param.id) {
                    return indice;
                }
            }), 1);
            params = params;
            
        }
        
    }

    function openModal(param: Param = null) {
        addParam = true;
        paramTypeModal = paramType;
        editParam = param;
        removeButton = (param == null) ? false : true;
        if (param == null) {
            editParam = new Param({
				id : v4uuid(), 
				name : '', 
				type : paramType
			});
        } else {
            editParam = param;
        }
    }

</script>

<style>

</style>

<div class="container-fluid p-5 pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12 text-end">
                <button class="btn btn-primary" type="button" on:click={() => {openModal()}}><Icon name="plus"/> Añadir
                </button>
            </div>
            {#if params?.length}
                {#each params as param, index }
                    <div class="col-6">
                        {param.name} 
                        <button class="btn btn-link btn-sm" type="button" on:click={() => {openModal(param)}}><Icon name="pencil-square"/>
                        </button>
                    </div>
                {/each}
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay Parámetros para mostrar</h3>
                </div>
            {/if}
        </div>
    </div>
</div>

<AddParamModal 
    bind:open={addParam}  
    type={paramTypeModal} 
    editParam={editParam} 
    removeButton={removeButton}
    on:addParam={(event) => addNewParam(event.detail)}
    on:removeParam={(event) => removeParam(event.detail)}
/>



